import { useEffect, useState } from "react";
import { BiCopy, BiData } from "react-icons/bi";
import { useNavigate, useParams } from "react-router-dom";
import MainData from "./Data/MainData";
import { BsGear } from "react-icons/bs";
import DbSettingsModal from "./Settings/DbSettingsModal";
import LoadingDB from "./LoadingDb";
import SmallAlert from "../../PlatformComponents/SmalAlert";
import LogsMain from "./Logs/LogsMain";
import { TbLogs } from "react-icons/tb";

const OpenNoSqlDB = () => {
    const user_id = sessionStorage.getItem("user_id");
    const { project_id, db_id, link_db, coll_id } = useParams()
    const navigate = useNavigate()
    const [records, setRecords] = useState([]);

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    const [openBackup, setOpenBackup] = useState(false)
    const [settings, setSettings] = useState({})
    const [dbName, setDbName] = useState(false)
    const [dbId, setDbId] = useState(false)
    const [copied, setCopied] = useState(false)
    const [totalOps, setTotalOps] = useState(0)
    const [totalSizeMb, setTotalSizeMb] = useState(0)
    const [appliedSize, setAppliedSize] = useState(0)

    const changePage = (page) => {
        navigate(`/project_panel/${project_id}/databases/${db_id}/${page}`)
    }

    const goBack = () => {
        navigate(`/project_panel/${project_id}/databases`)
    }

    useEffect(() => {
        if (user_id) {
            fetchRecords();
        } else {
            setError(true);
            setLoading(false);
        }
    }, []);

    const fetchRecords = async () => {
        setLoading(true)
        try {
            const response = await fetch("https://backend.erioon.com/get_specific_db", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ user_id, db_id }),
            });
            if (response.ok) {
                const result = await response.json();
                let accessData = result.databases || {};
                setDbName(accessData.db_name)
                setDbId(accessData._id)
                let filteredData = [];

                filteredData.push(accessData);
                const recordsArray = Object.values(filteredData);
                const settings = recordsArray[0]["settings"]
                setSettings(settings)
                setRecords(recordsArray);

                const collections = accessData.collections || {};
                let totalOps = 0;
                let totalSizemb = 0;

                Object.values(collections).forEach((collection) => {
                    totalOps += collection.current_ops || 0;
                    totalSizemb += collection.current_size_mb || 0;
                })

                let formattedSize;
                if (totalSizemb >= 1000) {
                    formattedSize = (totalSizemb / 1024).toFixed(2) + " GB"; // Using 1024 for binary GB
                } else {
                    formattedSize = totalSizemb.toFixed(2) + " MB";
                }

                let appliedFormattedSize;
                if (accessData.db_size_mb >= 1000) {
                    appliedFormattedSize = (accessData.db_size_mb / 1000).toFixed(2) + " GB"; // Using 1024 for binary GB
                } else {
                    appliedFormattedSize = accessData.db_size_mb.toFixed(2) + " MB";
                }

                setTotalSizeMb(formattedSize);
                setTotalOps(totalOps);
                setAppliedSize(appliedFormattedSize)

            } else {
                setError(true);
            }
            setLoading(false)
        } catch (err) {
            setLoading(false)
            setError(true);
        }
    };

    const handleCopyClick = () => {
        navigator.clipboard.writeText(dbId);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };

    return (
        <div>
            <div className="new_section_main_view">
                <p className="new_section_main_view_title">
                    <i className="fa-solid fa-chevron-left" onClick={goBack}></i> <span className={`fade-in ${dbName ? "new_section_main_view_title_span" : "new_section_main_view_title_span_loading"}`}>{dbName}</span>
                    <span className={`${dbId ? "new_section_main_view_title_db_id" : "new_section_main_view_title_db_id_loading"}`}>
                        {dbId}
                        {dbId && (
                            <i onClick={handleCopyClick}>
                                {copied ? (
                                    <i className="fa-solid fa-check fade-in"></i>
                                ) : (
                                    <BiCopy className="fade-in"/>
                                )}
                            </i>
                        )}
                    </span>
                    <span className={`${totalSizeMb ? "title_db_size" : "title_db_size_loading"}`}>
                        {totalSizeMb != 0 && (
                            <p className="title_db_size_item fade-in">{totalSizeMb} / {appliedSize} <i className="fa-solid fa-rotate" onClick={()=> fetchRecords()}></i></p>
                        )}
                    </span>
                </p>
                <p className="new_section_main_view_subtitle">
                    All the resources you need in a single page.
                </p>
                {!loading && (
                    <>
                        <SmallAlert message={"Backup for this database is disabled"} status={!settings.backup} functionToDo={setOpenBackup} />
                        <SmallAlert message={"Autoscale for this database is disabled"} status={!settings.autoscale} functionToDo={setOpenBackup} />
                    </>
                )}

                <div className="open_db_main_view">
                    <div className="open_db_main_navbar fade-in">
                        <div className="open_db_main_navbar_cont">
                            <button className={`open_db_main_btn ${link_db === "data" ? "open_db_main_btn_selected" : ""}`} onClick={() => changePage("data")}><BiData /> Data</button>
                            <button className={`open_db_main_btn ${link_db === "logs" ? "open_db_main_btn_selected" : ""}`} onClick={() => changePage("logs")}><TbLogs /> Logs</button>
                            {/* {loadingSync ? (
                                <div className="open_db_main_btn_loading"></div>
                            ) : (
                                <>
                                    {syncStatus ? (
                                        <button className="open_db_main_btn" onClick={() => setOpenBackupModal(true)}><BsCloudCheck /> Backup</button>
                                    ) : (
                                        <button className="open_db_main_btn open_db_main_btn_to_sync" onClick={() => setOpenBackupModal(true)}><MdOutlineBackup /> Backup</button>
                                    )}
                                </>
                            )} */}

                            {/* <button className={`open_db_main_btn ${link_db === "encryption" ? "open_db_main_btn_selected" : ""}`} onClick={() => changePage("encryption")}><MdOutlineEnhancedEncryption /> Encryption</button> */}
                            {/* <button className={`open_db_main_btn ${link_db === "migration" ? "open_db_main_btn_selected" : ""}`} onClick={() => changePage("migrations")}><BiTransfer /> Migration</button> */}
                        </div>
                        <div className="open_db_main_navbar_cont">
                            <button className="open_db_main_btn" onClick={() => setOpenBackup(true)}><BsGear /> Settings</button>
                        </div>
                    </div>
                    {loading ? (
                        <LoadingDB />
                    ) : (
                        <>
                            {link_db === "data" ? (
                                <MainData fetchRecords={fetchRecords} records={records} />
                            ) : link_db === "logs" ? (
                                <LogsMain fetchRecords={fetchRecords} records={records} dbName={dbName} />
                            ) : (
                                <></>
                            )}
                        </>
                    )}

                </div>
            </div>
            <DbSettingsModal
                show={openBackup}
                handleClose={() => setOpenBackup(false)}
                settings={settings}
                fetchRecords={fetchRecords}
            />
        </div>
    )
}

export default OpenNoSqlDB